import { createReducer } from 'typesafe-actions';

import { dismissToast, pushToast } from './actions';
import { Toast } from './types';

interface State {
    items: Toast[];
}

const initialState: State = {
    items: [],
};

export default createReducer(initialState as State)
    .handleAction(pushToast, (state, action) => ({
        items: [...state.items, action.payload],
    }))
    .handleAction(dismissToast, (state, action) => ({
        items: state.items.filter((toast) => toast.id !== action.payload),
    }));
